import Vue from 'vue';
import { SIDEBAR_TYPE, DEFAULT_THEME, DEFAULT_LAYOUT_MODE, DEFAULT_COLOR, DEFAULT_COLOR_WEAK, DEFAULT_FIXED_HEADER, DEFAULT_FIXED_SIDEMENU, DEFAULT_FIXED_HEADER_HIDDEN, DEFAULT_CONTENT_WIDTH_TYPE, DEFAULT_MULTI_PAGE } from "@/store/mutation-types";
var app = {
  state: {
    sidebar: {
      opened: true,
      withoutAnimation: false
    },
    device: 'desktop',
    theme: '',
    layout: '',
    contentWidth: '',
    fixedHeader: false,
    fixSiderbar: false,
    autoHideHeader: false,
    color: null,
    weak: false,
    requestHeaderParam: {
      _channel: 'PC'
    },
    multipage: true //默认多页签模式

  },
  mutations: {
    SET_REQUEST_HEADER_PARAM: function SET_REQUEST_HEADER_PARAM(state, requestHeaderParam) {
      state.requestHeaderParam = requestHeaderParam;
    },
    SET_SIDEBAR_TYPE: function SET_SIDEBAR_TYPE(state, type) {
      state.sidebar.opened = type;
      Vue.ls.set(SIDEBAR_TYPE, type);
    },
    CLOSE_SIDEBAR: function CLOSE_SIDEBAR(state, withoutAnimation) {
      Vue.ls.set(SIDEBAR_TYPE, true);
      state.sidebar.opened = false;
      state.sidebar.withoutAnimation = withoutAnimation;
    },
    TOGGLE_DEVICE: function TOGGLE_DEVICE(state, device) {
      state.device = device;
    },
    TOGGLE_THEME: function TOGGLE_THEME(state, theme) {
      // setStore('_DEFAULT_THEME', theme)
      Vue.ls.set(DEFAULT_THEME, theme);
      state.theme = theme;
    },
    TOGGLE_LAYOUT_MODE: function TOGGLE_LAYOUT_MODE(state, layout) {
      Vue.ls.set(DEFAULT_LAYOUT_MODE, layout);
      state.layout = layout;
    },
    TOGGLE_FIXED_HEADER: function TOGGLE_FIXED_HEADER(state, fixed) {
      Vue.ls.set(DEFAULT_FIXED_HEADER, fixed);
      state.fixedHeader = fixed;
    },
    TOGGLE_FIXED_SIDERBAR: function TOGGLE_FIXED_SIDERBAR(state, fixed) {
      Vue.ls.set(DEFAULT_FIXED_SIDEMENU, fixed);
      state.fixSiderbar = fixed;
    },
    TOGGLE_FIXED_HEADER_HIDDEN: function TOGGLE_FIXED_HEADER_HIDDEN(state, show) {
      Vue.ls.set(DEFAULT_FIXED_HEADER_HIDDEN, show);
      state.autoHideHeader = show;
    },
    TOGGLE_CONTENT_WIDTH: function TOGGLE_CONTENT_WIDTH(state, type) {
      Vue.ls.set(DEFAULT_CONTENT_WIDTH_TYPE, type);
      state.contentWidth = type;
    },
    TOGGLE_COLOR: function TOGGLE_COLOR(state, color) {
      Vue.ls.set(DEFAULT_COLOR, color);
      state.color = color;
    },
    TOGGLE_WEAK: function TOGGLE_WEAK(state, flag) {
      Vue.ls.set(DEFAULT_COLOR_WEAK, flag);
      state.weak = flag;
    },
    SET_MULTI_PAGE: function SET_MULTI_PAGE(state, multipageFlag) {
      Vue.ls.set(DEFAULT_MULTI_PAGE, multipageFlag);
      state.multipage = multipageFlag;
    }
  },
  actions: {
    setSidebar: function setSidebar(_ref, type) {
      var commit = _ref.commit;
      commit('SET_SIDEBAR_TYPE', type);
    },
    CloseSidebar: function CloseSidebar(_ref2, _ref3) {
      var commit = _ref2.commit;
      var withoutAnimation = _ref3.withoutAnimation;
      commit('CLOSE_SIDEBAR', withoutAnimation);
    },
    ToggleDevice: function ToggleDevice(_ref4, device) {
      var commit = _ref4.commit;
      commit('TOGGLE_DEVICE', device);
    },
    ToggleTheme: function ToggleTheme(_ref5, theme) {
      var commit = _ref5.commit;
      commit('TOGGLE_THEME', theme);
    },
    ToggleLayoutMode: function ToggleLayoutMode(_ref6, mode) {
      var commit = _ref6.commit;
      commit('TOGGLE_LAYOUT_MODE', mode);
    },
    ToggleFixedHeader: function ToggleFixedHeader(_ref7, fixedHeader) {
      var commit = _ref7.commit;

      if (!fixedHeader) {
        commit('TOGGLE_FIXED_HEADER_HIDDEN', false);
      }

      commit('TOGGLE_FIXED_HEADER', fixedHeader);
    },
    ToggleFixSiderbar: function ToggleFixSiderbar(_ref8, fixSiderbar) {
      var commit = _ref8.commit;
      commit('TOGGLE_FIXED_SIDERBAR', fixSiderbar);
    },
    ToggleFixedHeaderHidden: function ToggleFixedHeaderHidden(_ref9, show) {
      var commit = _ref9.commit;
      commit('TOGGLE_FIXED_HEADER_HIDDEN', show);
    },
    ToggleContentWidth: function ToggleContentWidth(_ref10, type) {
      var commit = _ref10.commit;
      commit('TOGGLE_CONTENT_WIDTH', type);
    },
    ToggleColor: function ToggleColor(_ref11, color) {
      var commit = _ref11.commit;
      commit('TOGGLE_COLOR', color);
    },
    ToggleWeak: function ToggleWeak(_ref12, weakFlag) {
      var commit = _ref12.commit;
      commit('TOGGLE_WEAK', weakFlag);
    },
    ToggleMultipage: function ToggleMultipage(_ref13, multipageFlag) {
      var commit = _ref13.commit;
      commit('SET_MULTI_PAGE', multipageFlag);
    }
  }
};
export default app;